module.exports = __webpack_public_path__ + "img/tianqi.7e8c140e.png";